/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IssuanceProfile,
  IssuanceProfile$inboundSchema,
} from "./issuanceprofile.js";

export type ListIssuanceProfilesResponseBody = {
  items: Array<IssuanceProfile>;
};

/** @internal */
export const ListIssuanceProfilesResponseBody$inboundSchema: z.ZodMiniType<
  ListIssuanceProfilesResponseBody,
  unknown
> = z.object({
  items: z.array(IssuanceProfile$inboundSchema),
});

export function listIssuanceProfilesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListIssuanceProfilesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIssuanceProfilesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIssuanceProfilesResponseBody' from JSON`,
  );
}
